import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { SpendResponseModel } from '@/types'

export const getSpendMetrics = async (
  branchName: string,
  startDate: string,
  endDate: string
): Promise<SpendResponseModel> => {
  try {
    const response = await axios.get(`${BASE_URL}/spend`, {
      params: {
        start_year_month: startDate,
        end_year_month: endDate,
        dcn: branchName,
        limit: 1000,
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
